import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=1fd94ded&scoped=true&"
import script from "./Partners.vue?vue&type=script&lang=js&"
export * from "./Partners.vue?vue&type=script&lang=js&"
import style0 from "./Partners.vue?vue&type=style&index=0&id=1fd94ded&scoped=true&lang=css&"
import style1 from "./Partners.vue?vue&type=style&index=1&id=1fd94ded&scoped=true&lang=css&"
import style2 from "./Partners.vue?vue&type=style&index=2&id=1fd94ded&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd94ded",
  null
  
)

export default component.exports